import { WithStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { IRootState } from '../../../../../typings';
import { ISide } from '../../../../matches/typings';
import { IMatchTeamPlayer } from '../../../../matchTeamPlayers/typings';
import {
  selectMatchTeamPlayerAction,
  unselectMatchTeamPlayerAction,
} from '../../actions';
import {
  selectIsSelectedMatchTeamPlayer,
  selectSelectedMatchTeamPlayer,
} from '../../selector';
import { styles } from './styles';

interface IOwnProps {
  matchTeamPlayer: IMatchTeamPlayer | null;
  disabled?: boolean;
  side: ISide;
  isSubtitute?: boolean;
  onAdd: () => void;
  onDelete: () => void;
  onSwap: () => void;
  title?: string;
}

const mapDispatchToProps = {
  selectMatchTeamPlayer: selectMatchTeamPlayerAction,
  unselectMatchTeamPlayer: unselectMatchTeamPlayerAction,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  return {
    isSelectedMatchTeamPlayer: selectIsSelectedMatchTeamPlayer(
      state,
      ownProps.side,
      ownProps.matchTeamPlayer
    ),
    selectedMatchTeamPlayer: selectSelectedMatchTeamPlayer(state, ownProps.side),
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  WithStyles &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  withStyles(styles)
);
